/* eslint-disable @typescript-eslint/no-unused-vars */
import { Flex, HStack, Link, Text } from '@chakra-ui/react'
import { themeColors } from 'theme'

import CustomNavLink from 'components/CustomNavLink'
import { FAQIcon, IconPropsType } from 'components/SVGS'


// TODO: Check Link genereate error in console, verify plz when refresh page context is empty :/
interface NavigationItem {
  onClick?: () => void | undefined
  key?: number
  icon: React.FC<IconPropsType>
  route: string
  isNavLink: boolean
}

export const NavigationItem: React.FC<NavigationItem> = ({ onClick, key,children, icon, route, isNavLink }) => {
  const {
    customButtons: { bgHoverColor, bgHoverText },
    drawer: { bgColor, bgActiveColor, bgActiveGradient: { gradientOne, gradientTwo } }
  } = themeColors

  return (
    <Link
      {...isNavLink ? { as: CustomNavLink } : { href: route }}
      {...!isNavLink && { isExternal: true }}
      route={route}
      icon={icon}
      px="4"
      py="2"
      gradient={`linear(to-br, ${gradientOne}, ${gradientTwo})`}
      rounded="3xl"
      w='full'
      cursor="pointer"
      className="iconContainer"
      transition=".15s ease"
      _hover={{ bg: bgHoverColor, color: bgHoverText }}
      onClick={onClick}
    >
      {!isNavLink ?
        <HStack justifyContent={'flex-start'} alignItems={'center'}>
          <Flex w={10} h={10}
            bg={bgActiveColor}
            rounded='lg'
            alignItems='center'
            color={bgColor}
            justifyContent='center'>
            <FAQIcon fill={bgColor} size={7} />
          </Flex>
          <Text color={bgActiveColor}>{children}</Text>
        </HStack>
        :
        children
      }

    </Link>
  )
}
